import { observer } from 'mobx-react-lite';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import { useAccessCheckoutContext } from 'screens/AccessExpressV3/context/AccessCheckoutProvider';
import { useModal } from 'hooks/useModal';
import { useCallback } from 'react';
import { AccessReviewOrderModal } from '../../ReviewOrderModal/AccessReviewOrderModal';
import { AccessReviewOrderForm } from 'api/accessexpressv3/schemas/AccessCheckoutSchemas';
import { useNavigate } from 'react-router-dom';

const CheckoutFooter = observer(() => {
  const cart = useCartContext();
  const { currentIndex, locations, isCheckoutFormValid, onSubmit, form } =
    useAccessCheckoutContext();
  const { isOpen, open, close } = useModal();

  const disablePlaceOrder = currentIndex !== locations.length - 1;

  const handleConfirmation = ({ order_name }: AccessReviewOrderForm) => {
    onSubmit({ ...form.getValues(), order_name });
  };

  const handleClose = useCallback(() => {
    close();
    cart.open();
  }, [cart, close]);

  const handlePlaceOrderClick = async () => {
    const isValid = await isCheckoutFormValid();
    if (!isValid) {
      return;
    }
    cart.close();
    open();
  };

  const navigate = useNavigate();

  const backToGrid = () => {
    cart.close();
    navigate('./order-services/access');
  };

  return (
    <div className="flex flex-col gap-4">
      <GraniteButton
        variant="tertiary"
        form="access-checkout-form"
        type="button"
        onClick={handlePlaceOrderClick}
        disabled={disablePlaceOrder}
      >
        Place order
      </GraniteButton>
      <GraniteButton variant="secondary" onClick={backToGrid}>
        Cancel
      </GraniteButton>
      <AccessReviewOrderModal
        onConfirmation={handleConfirmation}
        isOpen={isOpen}
        close={handleClose}
      />
    </div>
  );
});

export default CheckoutFooter;
